import { useState, useEffect } from 'react';
import { fetchDirections, fetchRouteInfo, buildTimetable } from '../services/timetableAPI';
import { getTodayDateStr } from '../utils/timetable';

export default function useTimetable(routeId) {
  const [routeInfo, setRouteInfo] = useState(null);
  const [directions, setDirections] = useState([]);
  const [directionId, setDirectionId] = useState(null);
  const [timetable, setTimetable] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Pobierz info o linii i dostępne kierunki
  useEffect(() => {
    if (!routeId) return;
    let cancelled = false;

    async function load() {
      try {
        setLoading(true);
        setError(null);
        const [info, dirs] = await Promise.all([
          fetchRouteInfo(routeId),
          fetchDirections(routeId),
        ]);
        if (cancelled) return;
        setRouteInfo(info);
        setDirections(dirs);
        if (dirs.length > 0 && directionId === null) {
          setDirectionId(dirs[0].directionId);
        }
      } catch (err) {
        if (!cancelled) {
          console.error('Błąd pobierania danych linii:', err);
          setError('Nie udało się pobrać danych linii');
          setLoading(false);
        }
      }
    }
    load();
    return () => { cancelled = true; };
  }, [routeId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Pobierz rozkład dla wybranego kierunku
  useEffect(() => {
    if (!routeId || directionId === null) return;
    let cancelled = false;

    async function load() {
      try {
        setLoading(true);
        setError(null);
        const dateStr = getTodayDateStr();
        const data = await buildTimetable(routeId, directionId, dateStr);
        if (!cancelled) {
          setTimetable(data);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          console.error('Błąd budowania rozkładu:', err);
          setError('Nie udało się zbudować rozkładu jazdy');
          setLoading(false);
        }
      }
    }
    load();
    return () => { cancelled = true; };
  }, [routeId, directionId]);

  return { routeInfo, directions, directionId, setDirectionId, timetable, loading, error };
}
